import React, { useEffect } from 'react';
import styled from 'styled-components';
import SectionHeader from '../components/SectionHeader';

const ValuesSection = styled.section`
  background-color: var(--bg-color);
`;

const ValueCard = styled.div`
  display: flex;
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  overflow: hidden;
  max-width: 800px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  margin: 0 auto 40px;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ValueNumber = styled.div`
  background-color: var(--primary-color);
  color: var(--secondary-color);
  font-size: 2.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  min-width: 100px;
  
  @media (max-width: 768px) {
    min-width: 100%;
    padding: 10px;
  }
`;

const ValueDetail = styled.div`
  padding: 30px;
  
  h3 {
    color: var(--secondary-color);
    margin-bottom: 15px;
  }
  
  p {
    font-size: 1.1rem;
    line-height: 1.6;
    
    @media (max-width: 576px) {
      font-size: 1rem;
    }
  }
`;

const ValuesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 50px;
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const ValueItem = styled.div`
  background-color: rgba(30, 43, 15, 0.8);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  transition-delay: ${props => props.delay || '0s'};
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
    border-color: var(--secondary-color);
  }
`;

const ValueIcon = styled.div`
  font-size: 2.5rem;
  color: var(--secondary-color);
  margin-bottom: 20px;
`;

const Values = () => {
  useEffect(() => {
    const handleScroll = () => {
      const valueCard = document.getElementById('value-card');
      const valueItems = document.querySelectorAll('.value-item');
      
      if (valueCard) {
        const position = valueCard.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.75) {
          valueCard.classList.add('animate');
        }
      }
      
      valueItems.forEach(item => {
        const position = item.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (position.top < windowHeight * 0.75) {
          item.classList.add('animate');
        }
      });
    };
    
    window.addEventListener('scroll', handleScroll);
    // Initial check
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <ValuesSection id="valores">
      <div className="container">
        <SectionHeader title="Nossos Valores" highlight="Valores" />
        <ValueCard id="value-card">
          <ValueNumber>02</ValueNumber>
          <ValueDetail>
            <h3>Valores Fundamentais</h3>
            <p>
              Valorizamos princípios como integridade, colaboração, excelência e precisão, 
              que moldam a nossa cultura organizacional e impulsionam nosso 
              compromisso em entregar resultados de qualidade para nossos clientes.
            </p>
          </ValueDetail>
        </ValueCard>
        <ValuesGrid>
          <ValueItem className="value-item" delay="0s">
            <ValueIcon>
              <i className="fas fa-shield-alt"></i>
            </ValueIcon>
            <h4>Integridade</h4>
            <p>Mantemos os mais altos padrões éticos em tudo o que fazemos.</p>
          </ValueItem>
          <ValueItem className="value-item" delay="0.2s">
            <ValueIcon>
              <i className="fas fa-users"></i>
            </ValueIcon>
            <h4>Colaboração</h4>
            <p>Trabalhamos como uma unidade coordenada para atingir objetivos.</p>
          </ValueItem>
          <ValueItem className="value-item" delay="0.4s">
            <ValueIcon>
              <i className="fas fa-medal"></i>
            </ValueIcon>
            <h4>Excelência</h4>
            <p>Buscamos a perfeição em cada linha de código e em cada projeto.</p>
          </ValueItem>
          <ValueItem className="value-item" delay="0.6s">
            <ValueIcon>
              <i className="fas fa-crosshairs"></i>
            </ValueIcon>
            <h4>Precisão</h4>
            <p>Focamos em detalhes e entregamos resultados com exatidão.</p>
          </ValueItem>
        </ValuesGrid>
      </div>
    </ValuesSection>
  );
};

export default Values;